import React, {Component} from 'react';
import {Button, Form, Input, Row, Col} from 'antd';
import request from 'superagent';
import NotificationManager from '../../../commons/CustomNotificationManager.js';
import AlertConfigurationPagerdutyHelp from './AlertConfigurationPagerdutyHelp.js';
import AlertConfigurationTeamsHelp from './AlertConfigurationTeamsHelp.js';
import AlertConfigurationServiceMsgConfirm from './AlertConfigurationServiceMsgConfirm.js';

const FormItem = Form.Item;

class AlertConfigurationNotificationForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            notifications: this.props.notifications,
            loading: this.props.loading,
            save: false
        };
    }

    componentDidMount() {
        let notifications = this.props.notifications;
        this.props.form.setFieldsValue({
            pagerdutyUrl: notifications.pagerduty.url,
            pagerdutyIntegrationKey: notifications.pagerduty.integrationKey,
            pagerdutyStatus: notifications.pagerduty.status,
            teamsUrl: notifications.teams.url
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.save) {
            let notifications = nextProps.notifications;
            this.props.form.setFieldsValue({
                pagerdutyUrl: notifications.pagerduty.url,
                pagerdutyIntegrationKey: notifications.pagerduty.integrationKey,
                pagerdutyStatus: notifications.pagerduty.status,
                teamsUrl: notifications.teams.url
            });
        }
        this.setState({
            notifications: nextProps.notifications,
            loading: nextProps.loading,
            save: false
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let notifications = this.state.notifications;
                notifications.pagerduty.url = values.pagerdutyUrl;
                notifications.pagerduty.integrationKey = values.pagerdutyIntegrationKey;
                notifications.pagerduty.status = values.pagerdutyStatus;
                notifications.teams.url = values.teamsUrl;
                const data = {notifications: notifications};
                request.post('/api/dashboard/alert/configuration/notificationSave')
                    .withCredentials()
                    .set('Content-Type', 'application/json; charset=utf-8')
                    .send(data)
                    .end((error, response) => {
                        if (!error && response) {
                            this.props.onSuccess();
                            this.setState({save: true});
                            NotificationManager.success('Succeed to save configuration.');
                        } else {
                            //console.log("Error while save configuration.", error);
                            NotificationManager.error('Failed to save configuration.');
                        }
                    });
            }
        });
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 10},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 14},
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 0,
                },
            },
        };

        return (
            <div className="page-container">
                <div style={{marginLeft: 15}}>
                    <div className="panel-body">
                        <div>
                            <Form onSubmit={this.handleSubmit} style={{maxWidth: 800}}>
                                <div>
                                    <div className="pager-duty">
                                        <div className="logo"></div>
                                        <div className="hr-dashed sub-title-line"></div>
                                    </div>
                                    <FormItem {...formItemLayout} label="Pagerduty URL">
                                        {getFieldDecorator('pagerdutyUrl', {})(
                                            <Input disabled={true}/>
                                        )}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label={(<span>Pagerduty Integration Key&nbsp;
                                        <AlertConfigurationPagerdutyHelp/></span>)}>
                                        {getFieldDecorator('pagerdutyIntegrationKey', {})(
                                            <Input />
                                        )}
                                    </FormItem>
                                    <FormItem {...formItemLayout} label="Status">
                                        <Row gutter={8}>
                                            <Col span={16}>
                                                {getFieldDecorator('pagerdutyStatus', {})(
                                                    <Input disabled={true}/>
                                                )}
                                            </Col>
                                            <Col span={8}>
                                                <Button>Pin Status</Button>
                                            </Col>
                                        </Row>
                                    </FormItem>
                                    <div className="teams">
                                        <div className="logo"></div>
                                        <div className="hr-dashed sub-title-line"></div>
                                    </div>
                                    <FormItem {...formItemLayout}
                                              label={(<span>Teams URL&nbsp;<AlertConfigurationTeamsHelp/></span>)}>
                                        {getFieldDecorator('teamsUrl', {})(
                                            <Input disabled={true}/>
                                        )}
                                    </FormItem>
                                </div>
                                <div className="hr-dashed"></div>
                                <FormItem {...tailFormItemLayout}>
                                    {/*<Button type="primary" htmlType="submit" className="login-form-button">
                                        Save
                                    </Button>*/}
                                    <AlertConfigurationServiceMsgConfirm handleSubmit={this.handleSubmit}/>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
const AlertConfigurationNotification = Form.create()(AlertConfigurationNotificationForm);
export default AlertConfigurationNotification;


// WEBPACK FOOTER //
// ./src/modules/dashboard/alert-configuration/AlertConfigurationNotification.js